import { ReactNode } from 'react';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { ExpiredTime } from '../../misc';

interface MultipleMissionCardProps {
  children: ReactNode;
  sectionTitle?: string;
  showExpiredTime?: boolean;
  daysUntilExpiration?: number;
}

export const MultipleMissionCard = ({
  children,
  sectionTitle,
  showExpiredTime,
  daysUntilExpiration,
}: MultipleMissionCardProps) => (
  <div>
    <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5', mb: 16 })}>{sectionTitle}</p>
    {showExpiredTime && daysUntilExpiration !== undefined && <ExpiredTime daysUntilExpiration={daysUntilExpiration} />}
    <div
      className={stack({
        borderTopRadius: showExpiredTime ? undefined : 8,
        borderBottomRadius: 8,
        py: { base: 16, tablet: 24 },
        px: { base: 12, tablet: 0 },
        background: 'background.default.level-1',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      })}
    >
      {children}
    </div>
  </div>
);
